var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tds-checkbox",on:{"click":function($event){$event.preventDefault();return _vm.$emit('update:activated', !_vm.activated)}}},[_c('span',{staticClass:"checkbox",class:_vm.activated ? 'activated' : ''},[_vm._v("✓")]),_c('label',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }